import { NetworkCode } from "@/interfaces/blockchainNetwork";

const ETH_REGEX = /^0x[a-fA-F0-9]{40}$/;

const BTC_REGEX = /^(bc1|[13])[a-zA-HJ-NP-Z0-9]{25,62}$/;

const TRON_REGEX = /^T[A-Za-z1-9]{33}$/;

const SOLANA_REGEX = /^[1-9A-HJ-NP-Za-km-z]{32,44}$/;

export function validateBlockchainAddress(
  network: NetworkCode,
  address: string,
): boolean {
  switch (network) {
    case NetworkCode.ETH:
    case NetworkCode.BSC:
    case NetworkCode.POLYGON:
    case NetworkCode.ARBITRUM:
    case NetworkCode.BASE:
    case NetworkCode.OPTIMISM:
    case NetworkCode.AVALANCHE:
      return ETH_REGEX.test(address);

    case NetworkCode.TRON:
      return TRON_REGEX.test(address);

    case NetworkCode.BTC:
      return BTC_REGEX.test(address);

    case NetworkCode.SOL:
      return SOLANA_REGEX.test(address);

    default:
      return false;
  }
}
